export const comments_5256815 = {"data":{"data":[],"links":{}}}